var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-empty",
        {
          attrs: { image: _vm.img, "image-size": 223, description: "请求超时" },
        },
        [
          _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
            _vm._v("刷新"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }